import React, { useContext, useEffect, useState } from "react";
import "./ProjectList.css";
import { useLanguage } from "../../../../LanguageProvider";
import { GeneralContext } from "../../../../GeneralProvider";
import AddProjectModal from "../../../../components/Header/components/TabsHolder/Views/AddProjectModal";
import CollaboratorsTable from "../../../CollaboratorsPage/components/CollaboratorsTable/CollaboratorsTable";
import AlertBox from "../../../../components/AlertBox/AlertBox";

export default function ProjectList({ selectedProjectID }) {
  const { getTranslation } = useLanguage();
  const {
    projects,
    handleAddSubProject,
    handleDeleteSubProject,
    handleUpdateSubProject,
  } = useContext(GeneralContext);

  // Delete için seçilen subProject'in id'si
  const [selectedSubProjectIdForDelete, setSelectedSubProjectIdForDelete] =
    useState("");
  // Edit için seçilen subProject objesini saklıyoruz
  const [selectedSubProjectForEdit, setSelectedSubProjectForEdit] =
    useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [subProjectsTableData, setSubProjectsTableData] = useState([]);
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  useEffect(() => {
    if (projects && Array.isArray(projects)) {
      const selectedProject = projects.find(
        (project) => project.projectID === selectedProjectID
      );
      if (
        selectedProject &&
        selectedProject.subProjects &&
        selectedProject.subProjects.length > 0
      ) {
        const truncate = (text, maxLength) => {
          if (!text) return "";
          return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
        };
  
        const tableData = selectedProject.subProjects.map((sub) => ({
          title: sub.title,
          description: truncate(sub.description, 15), // burada kısaltma
          actions: (
            <div style={{ display: "flex", gap: "8px" }}>
              <button onClick={() => handleEdit(sub)}>
                {getTranslation("edit")}
              </button>
              <button
                onClick={() => {
                  setIsAlertOpen(true);
                  setSelectedSubProjectIdForDelete(sub.subProjectId);
                }}
              >
                {getTranslation("delete")}
              </button>
            </div>
          ),
        }));
        setSubProjectsTableData(tableData);
      } else {
        setSubProjectsTableData([]);
      }
    }
  }, [projects, selectedProjectID, getTranslation]);
  

  // Yeni subProject ekleme
  const handleAddProject = async (title, description) => {
    try {
      await handleAddSubProject(title, description);
    } catch (error) {
      console.error("Error while adding project:", error);
    }
  };

  // Edit edilen subProject güncelleme
  const handleEditProject = async (title, description) => {
    const updateData = {
      title: title,
      description: description,
    };
    try {
      await handleUpdateSubProject(
        selectedSubProjectForEdit.subProjectId,
        updateData
      );
    } catch (error) {
      console.error("Error while edited project:", error);
    }
  };

  // Edit butonuna tıklanınca, ilgili subProject bilgisini state'e aktar ve edit modal'ı aç
  const handleEdit = (subProject) => {
    setSelectedSubProjectForEdit(subProject);
    setIsEditModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    setIsAlertOpen(false);
    try {
      await handleDeleteSubProject(selectedSubProjectIdForDelete);
    } catch (error) {
      console.log(error);
    }
    setSelectedSubProjectIdForDelete("");
  };

  const headers = [
    getTranslation("title"),
    getTranslation("description"),
    getTranslation("actions"),
  ];

  const fieldMapping = {
    [getTranslation("title")]: "title",
    [getTranslation("description")]: "description",
    [getTranslation("actions")]: "actions",
  };

  return (
    <div className="project-list">
      <p className="project-list-title">{getTranslation("projectList")}</p>
      <div className="project-list-row">
        <button onClick={() => setIsModalOpen(true)}>
          {getTranslation("addNewProject")}
        </button>
      </div>

      <CollaboratorsTable
        headers={headers}
        data={subProjectsTableData}
        fieldMapping={fieldMapping}
      />

      <AlertBox
        isOpen={isAlertOpen}
        title={getTranslation("areYouSure")}
        message={getTranslation("projectDeleteWarning")}
        onConfirm={handleConfirmDelete}
        onCancel={() => setIsAlertOpen(false)}
        confirmText={getTranslation("yes")}
        cancelText={getTranslation("no")}
        type={"warning"}
      />

      <AddProjectModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onCreate={handleAddProject}
      />

      <AddProjectModal
        isOpen={isEditModalOpen}
        isEdit={true}
        onClose={() => {setIsEditModalOpen(false);  setSelectedSubProjectForEdit(null);}}
        onCreate={handleEditProject}
        title={selectedSubProjectForEdit ? selectedSubProjectForEdit.title : ""}
        description={
          selectedSubProjectForEdit ? selectedSubProjectForEdit.description : ""
        }
      />
    </div>
  );
}
